import { Controller } from "@hotwired/stimulus";

// Stellt sicher, dass die Inbox nach einem Browser-Back
// mit dem aktuellen Read/Unread-Status neu geladen wird.
export default class extends Controller {
  connect() {
    const navEntries = performance.getEntriesByType("navigation");
    const nav = navEntries[0];

    if (nav && nav.type === "back_forward") {
      window.Turbo?.visit(window.location.href, { action: "replace" });
    }
  }
}

